import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
export default {
  data: function data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'authorityName'
      },
      roleList: [],
      checkAll: false,
      isIndeterminateAll: false,
      positionAuthorities: []
    };
  },
  created: function created() {
    this.dataBind();
  },
  methods: {
    emitRole: function emitRole() {
      var setActive = function setActive(arr) {
        return arr.map(function (m) {
          return _objectSpread(_objectSpread({}, m), {}, {
            active: m.check || m.isIndeterminate
          });
        });
      }; // return this.roleList


      return setActive(this.roleList);
    },
    emitSetRole: function emitSetRole(pos) {
      this.roleList = this.setPermissionsDetail(pos);
    },
    emitRoleLost: function emitRoleLost(arr) {
      this.roleList = this.setPermissionsDetail(arr);
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(e, l) {
      var checkedCount = l.positionAuthorities.length;
      this.$set(l, 'isIndeterminate', checkedCount > 0 && checkedCount < l.children.length);
      this.$set(l, 'check', checkedCount === l.children.length);

      if (l.check) {} else {
        this.checkAll = false;
        this.isIndeterminateAll = true;
      }
    },
    handleCheckChange: function handleCheckChange(e, l) {
      console.log(e, l);

      if (e) {
        l.children.forEach(function (v) {
          l.positionAuthorities.push(v.authorityValue);
        });
        this.$set(l, 'isIndeterminate', false);
        this.$set(l, 'check', e);
      } else {
        this.$set(l, 'isIndeterminate', e);
        this.$set(l, 'positionAuthorities', []);
      }
    },
    //全部选择
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.roleList.forEach(function (v) {
        if (val) {
          v.check = true;
          v.isIndeterminate = false;
          v.children.forEach(function (k) {
            return v.positionAuthorities.push(k.authorityValue);
          });
        } else {
          v.check = false;
          v.isIndeterminate = false;
          v.children.forEach(function (k) {
            return v.positionAuthorities = v.positionAuthorities.splice(0, -1);
          });
        }
      });
    },
    dataBind: function dataBind(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, query, _yield$_this$$api$sta, positionAuthorities;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.authorities();

              case 2:
                res = _context.sent;
                _this.roleList = _this.setPermissions(res);
                query = _this.$route.query;

                if (!(JSON.stringify(query) !== '{}')) {
                  _context.next = 11;
                  break;
                }

                _context.next = 8;
                return _this.$api.staffDetails(query);

              case 8:
                _yield$_this$$api$sta = _context.sent;
                positionAuthorities = _yield$_this$$api$sta.positionAuthorities;
                _this.roleList = _this.setPermissionsDetail(positionAuthorities);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    //详情递归添加字段
    setPermissionsDetail: function setPermissionsDetail(arr) {
      return arr.map(function (v) {
        var check = v.children && v.children.every(function (v) {
          return v.active;
        });
        var isIndeterminate = v.children && v.children.some(function (v) {
          return v.active;
        });

        var obj = _objectSpread(_objectSpread({}, v), {}, {
          check: v.active,
          isIndeterminate: !!check ? false : isIndeterminate,
          positionAuthorities: [],
          children: v.children ? v.children : []
        });

        if (obj.children && obj.children.length > 0) {
          obj.children.forEach(function (k) {
            k.active && obj.positionAuthorities.push(k.authorityValue);
          });
        }

        return obj;
      });
    },
    //递归添加字段
    setPermissions: function setPermissions(arr) {
      var _this2 = this;

      return arr.map(function (v) {
        var obj = _objectSpread(_objectSpread({}, v), {}, {
          check: false,
          isIndeterminate: false,
          positionAuthorities: [],
          children: v.children ? v.children : []
        });

        if (obj.children && obj.children.length > 0) {
          obj.children = _this2.setPermissions(obj.children);
        }

        return obj;
      });
    },
    confirm: function confirm() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data, positionId, params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = cloneDeep(_this3.roleList);
                positionId = _this3.$route.query.positionId;
                params = {
                  positionId: positionId,
                  positionAuthorities: []
                };
                data.forEach(function (v) {
                  var positionLen = v.positionAuthorities.length;

                  if (positionLen > 0) {
                    v.active = true;
                    v.children = v.children.map(function (k) {
                      if (v.positionAuthorities.includes(k.authorityValue)) {
                        return _objectSpread(_objectSpread({}, k), {}, {
                          active: true
                        });
                      } else {
                        return _objectSpread(_objectSpread({}, k), {}, {
                          active: false
                        });
                      }
                    });
                    params.positionAuthorities.push(v);
                  } else {
                    if (v.check) v.active = v.check;
                    v.children = v.children.map(function (k) {
                      return _objectSpread(_objectSpread({}, k), {}, {
                        active: false
                      });
                    });
                    params.positionAuthorities.push(v);
                  }
                });
                _context2.next = 6;
                return _this3.$api.saveAuthorities(params);

              case 6:
                _this3.$notify.success({
                  title: '成功',
                  message: '添加成功'
                });

                _this3.goBack();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};